/**
 * 锚点 Tab 模块脚本
 * 对应 section：sections/anchor-point.liquid
 * 功能：点击 tab 平滑滚动到锚点；滚动时自动高亮当前 tab；tabs 吸顶固定
 */
(function () {
  // 已初始化则直接复用，避免重复绑定
  if (window.BoyaAnchorPoint) {
    window.BoyaAnchorPoint.initAll(document);
    return;
  }

  /** 从 #id、完整 URL 或纯 id 中提取固定锚点。 */
  function normalizeAnchorId(anchor) {
    if (!anchor) return '';
    var value = String(anchor).trim();
    var hashIndex = value.lastIndexOf('#');
    if (hashIndex >= 0) value = value.slice(hashIndex + 1);
    value = value.replace(/^#/, '');
    if (!value) return '';
    try {
      return decodeURIComponent(value);
    } catch (e) {
      return value;
    }
  }

  /** 解码 Liquid 输出的固定锚点键；该键不会交给翻译软件处理。 */
  function decodeAnchorKey(value) {
    if (!value || typeof window.atob !== 'function') return '';
    try {
      var binary = window.atob(String(value).trim());
      var encoded = '';
      for (var i = 0; i < binary.length; i++) {
        encoded += '%' + ('00' + binary.charCodeAt(i).toString(16)).slice(-2);
      }
      return decodeURIComponent(encoded);
    } catch (e) {
      return '';
    }
  }

  /** 把修复后的技术锚点重新写回不可见保护键，后续翻译更新不再影响它。 */
  function encodeAnchorKey(value) {
    if (!value || typeof window.btoa !== 'function') return '';
    try {
      return window.btoa(unescape(encodeURIComponent(String(value))));
    } catch (e) {
      return '';
    }
  }

  /**
   * 技术锚点与可见标题完全解耦：
   * 1. 优先使用隐藏且禁止翻译的 Base64 锚点键；
   * 2. 其次使用标准 href 的 URL fragment；
   * 3. data-anchor 仅作为旧模板兼容兜底。
   */
  function getTabAnchorId(tab) {
    if (!tab) return '';
    if (tab.__boyaAnchorId) return tab.__boyaAnchorId;

    var protectedKey = tab.querySelector('[data-ap-anchor-key]');
    var id = protectedKey
      ? normalizeAnchorId(decodeAnchorKey(protectedKey.getAttribute('data-ap-anchor-key')))
      : '';
    if (!id) id = normalizeAnchorId(tab.getAttribute('href'));
    if (!id) id = normalizeAnchorId(tab.getAttribute('data-anchor'));

    if (id) tab.__boyaAnchorId = id;
    return id;
  }

  /** 根据固定锚点 id 查找目标元素，不读取也不推导 Tab 标题。 */
  function resolveTarget(anchor) {
    var id = normalizeAnchorId(anchor);
    if (!id) return null;
    try {
      return document.getElementById(id) || document.getElementsByName(id)[0] || null;
    } catch (e) {
      return null;
    }
  }

  /**
   * HTML 与 SVG 的 id 属性接口并不完全相同：SVGElement.id 在部分浏览器中可能是
   * SVGAnimatedString。统一通过 getAttribute 读取，确保后续字符串方法永不抛错。
   */
  function getElementId(element) {
    if (!element || typeof element.getAttribute !== 'function') return '';
    var value = element.getAttribute('id');
    return typeof value === 'string' ? value : '';
  }

  /** 当前产品 handle 不随页面语言前缀变化，可用于恢复被翻译器删掉的锚点前缀。 */
  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    if (!match || !match[1]) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (e) {
      return match[1];
    }
  }

  /**
   * 兼容已被 Transcy 保存成 #-5 之类的历史翻译：
   * 1. 优先用产品 handle 恢复 magic-5；
   * 2. 再用末尾稳定编号查找唯一/最短的真实目标 ID。
   */
  function recoverTranslatedTarget(anchor) {
    var id = normalizeAnchorId(anchor);
    if (!id) return null;

    var suffixMatch = id.match(/(-[a-z0-9]+)$/i);
    if (!suffixMatch) return null;
    var stableSuffix = suffixMatch[1];
    var productHandle = getProductHandle();

    if (productHandle) {
      var productTarget = document.getElementById(productHandle + stableSuffix);
      if (productTarget) return productTarget;
    }

    var candidates = Array.prototype.filter.call(document.querySelectorAll('[id]'), function (element) {
      var candidateId = getElementId(element);
      return candidateId
        && candidateId.slice(-stableSuffix.length) === stableSuffix
        && element.namespaceURI === 'http://www.w3.org/1999/xhtml'
        && !element.matches('input, select, option, textarea, button, style, script, link, meta')
        && !element.closest('[data-anchor-point]');
    });

    if (!candidates.length) return null;
    candidates.sort(function (a, b) {
      return getElementId(a).length - getElementId(b).length;
    });
    return candidates[0];
  }

  function repairTabAnchor(tab, target) {
    var canonicalId = getElementId(target);
    if (!tab || !canonicalId) return;
    tab.__boyaAnchorId = canonicalId;
    tab.setAttribute('href', '#' + canonicalId);
    tab.setAttribute('data-anchor', canonicalId);

    var protectedKey = tab.querySelector('[data-ap-anchor-key]');
    var encodedKey = encodeAnchorKey(canonicalId);
    if (protectedKey && encodedKey) {
      protectedKey.setAttribute('data-ap-anchor-key', encodedKey);
    }
  }

  function resolveTabTarget(tab) {
    if (tab && tab.__boyaTargetElement && document.documentElement.contains(tab.__boyaTargetElement)) {
      repairTabAnchor(tab, tab.__boyaTargetElement);
      return tab.__boyaTargetElement;
    }
    var anchorId = getTabAnchorId(tab);
    var target = resolveTarget(anchorId) || recoverTranslatedTarget(anchorId);
    if (target) {
      tab.__boyaTargetElement = target;
      repairTabAnchor(tab, target);
    }
    return target;
  }

  function getMaxScrollLeft(tabsWrap) {
    if (!tabsWrap) return 0;
    return Math.max(0, tabsWrap.scrollWidth - tabsWrap.clientWidth);
  }

  /** 记录导航的实际横向边界，供 PC、移动端和溢出提示共同使用。 */
  function updateTabsOverflowState(tabsWrap) {
    if (!tabsWrap) return;
    var edgeTolerance = 2;
    var maxScrollLeft = getMaxScrollLeft(tabsWrap);
    var isOverflowing = maxScrollLeft > edgeTolerance;
    tabsWrap.classList.toggle('is-overflowing', isOverflowing);
    tabsWrap.classList.toggle('can-scroll-left', isOverflowing && tabsWrap.scrollLeft > edgeTolerance);
    tabsWrap.classList.toggle('can-scroll-right', isOverflowing && tabsWrap.scrollLeft < maxScrollLeft - edgeTolerance);
  }

  /**
   * 仅移动导航自身：首项贴左、末项贴右，其余选中项居中。
   * 不使用 scrollIntoView，避免横向定位时意外带动页面纵向滚动。
   */
  function scrollTabIntoView(tabsWrap, tab, behavior) {
    if (!tabsWrap || !tab) return;

    window.requestAnimationFrame(function () {
      updateTabsOverflowState(tabsWrap);
      var tabs = Array.prototype.slice.call(tabsWrap.querySelectorAll('.ap-tab'));
      var tabIndex = tabs.indexOf(tab);
      var maxScrollLeft = getMaxScrollLeft(tabsWrap);
      var targetLeft = 0;

      if (maxScrollLeft <= 2 || tabIndex <= 0) {
        targetLeft = 0;
      } else if (tabIndex === tabs.length - 1) {
        targetLeft = maxScrollLeft;
      } else {
        var wrapRect = tabsWrap.getBoundingClientRect();
        var tabRect = tab.getBoundingClientRect();
        targetLeft = tabsWrap.scrollLeft
          + tabRect.left
          + (tabRect.width / 2)
          - wrapRect.left
          - (wrapRect.width / 2);
        targetLeft = Math.max(0, Math.min(maxScrollLeft, targetLeft));
      }

      var shouldAnimate = behavior !== 'auto'
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (shouldAnimate && typeof tabsWrap.scrollTo === 'function') {
        tabsWrap.scrollTo({ left: Math.round(targetLeft), behavior: 'smooth' });
      } else {
        tabsWrap.scrollLeft = Math.round(targetLeft);
      }
    });
  }

  /** 初始化单个模块实例 */
  function initSection(section) {
    if (!section || section.dataset.apBound === '1') return;
    section.dataset.apBound = '1';

    // 故障保护：任何第三方脚本或异常都不能让导航永久处于 aria-busy 状态。
    var revealFallbackTimer = window.setTimeout(function () {
      section.classList.remove('ap-is-pending');
      section.removeAttribute('aria-busy');
    }, 1500);

    var tabs = Array.prototype.slice.call(section.querySelectorAll('.ap-tab'));
    var tabsWrap = section.querySelector('.ap-tabs');
    if (!tabs.length || !tabsWrap) {
      window.clearTimeout(revealFallbackTimer);
      section.classList.remove('ap-is-pending');
      section.removeAttribute('aria-busy');
      return;
    }

    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var enterTimer = null;
    var leaveTimer = null;
    /* 对齐 Apple localnav：短时下滑进入 / 上滑退出；时长须与 CSS keyframes 一致 */
    var shapeEnterDuration = 200;
    var contentEnterDuration = 0;
    var contentEnterStart = 0;
    var maxStaggeredItems = 0;
    var enterStagger = 0;
    var exitContentDuration = 0;
    var exitStagger = 0;
    var shapeExitDuration = 160;
    var staggeredItemCount = Math.min(Math.max(0, tabs.length - 1), maxStaggeredItems);
    var enterTotalDuration = shapeEnterDuration
      + contentEnterStart
      + (staggeredItemCount * enterStagger)
      + contentEnterDuration;
    var exitShapeDelay = exitContentDuration + (staggeredItemCount * exitStagger);
    var exitTotalDuration = exitShapeDelay + shapeExitDuration;

    tabs.forEach(function (tab, index) {
      // 在第三方翻译脚本运行前缓存技术锚点，后续只允许标题文本发生变化。
      getTabAnchorId(tab);
      // 同时修复 Transcy 旧翻译中可能已变成 #-5 的锚点，并恢复标准 href。
      try {
        resolveTabTarget(tab);
      } catch (error) {
        // 单个异常锚点降级为原生 href，不阻断其余 Tab 与整个导航的初始化。
        tab.__boyaAnchorId = normalizeAnchorId(tab.getAttribute('href'))
          || normalizeAnchorId(tab.getAttribute('data-anchor'));
      }
      var enterIndex = Math.min(index, maxStaggeredItems);
      var exitIndex = Math.min(Math.max(0, tabs.length - index - 1), maxStaggeredItems);
      tab.style.setProperty('--ap-enter-delay', (contentEnterStart + enterIndex * enterStagger) + 'ms');
      tab.style.setProperty('--ap-exit-delay', (exitIndex * exitStagger) + 'ms');
    });
    tabsWrap.style.setProperty('--ap-exit-shape-delay', exitShapeDelay + 'ms');

    // 吸顶占位：固定后保持文档流高度，避免页面抖动
    var spacer = document.createElement('div');
    spacer.className = 'ap-sticky-spacer';
    tabsWrap.parentNode.insertBefore(spacer, tabsWrap);

    // 记录 tabs 吸顶触发位置（相对文档）：由前面的 .sec__featured-product 模块底部决定
    var stickTriggerTop = 0;
    var isSticky = false;

    // 查找当前 anchor 模块之前最近的 .sec__featured-product 模块
    function findFeaturedProduct() {
      var node = section.previousElementSibling;
      while (node) {
        if (node.classList && node.classList.contains('sec__featured-product')) return node;
        node = node.previousElementSibling;
      }
      // 兜底：页面内第一个 featured-product
      return document.querySelector('.sec__featured-product');
    }

    var featuredProduct = findFeaturedProduct();
    // 关联了 featured-product 模块时，给 section 标记，使 tabs 在其未滚动完前隐藏
    if (featuredProduct) {
      section.classList.add('has-featured');
    }

    /** 观察 featured-product 尺寸变化（含懒加载图片、内容异步加载等导致的高度变化），
     *  高度变化时重算 stickTriggerTop，避免 tabs 提前出现。
     *  兜底：图片 load 事件直接重算（兼容 ResizeObserver 不可用的环境） */
    if (featuredProduct && 'ResizeObserver' in window) {
      var featuredResizeObs = new ResizeObserver(function () {
        measureOrigin();
        updateSticky();
      });
      featuredResizeObs.observe(featuredProduct);
      // 监听 featured 内所有图片，load 后立即重算
      featuredProduct.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', function () {
            measureOrigin();
            updateSticky();
          }, { once: true });
          img.addEventListener('error', function () {
            measureOrigin();
            updateSticky();
          }, { once: true });
        }
      });
    }

    function measureOrigin() {
      if (featuredProduct) {
        // 吸顶触发点 = featured-product 模块底部（滚出视口后才显示 tabs）
        var rect = featuredProduct.getBoundingClientRect();
        stickTriggerTop = rect.bottom + window.pageYOffset;
      } else if (spacer.classList.contains('is-active')) {
        // 吸顶期间直接读取原位占位元素，避免临时移除 fixed 类导致动画重启。
        stickTriggerTop = spacer.getBoundingClientRect().top + window.pageYOffset;
      } else {
        // 无 featured-product 时退回 tabs 自身原始位置
        stickTriggerTop = tabsWrap.getBoundingClientRect().top + window.pageYOffset;
      }
    }

    /** 吸顶态下的滚动偏移：扣除吸顶 tabs 实际占用高度 + 当前 header 显示高度，避免锚点被遮挡
     *  - offsetHeight 不含外边距，需额外加上当前设备的吸顶 margin-top，否则落点偏低、需多滚一点
     *  - 动态读取 marginTop 而非写死，兼容吸顶/非吸顶、PC/移动端一致 */
    function getScrollOffset() {
      var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 0;
      var marginTop = parseFloat(getComputedStyle(tabsWrap).marginTop) || 0;
      return (tabsWrap.offsetHeight || 0) + marginTop + headerH;
    }

    /**
     * 仅在 Shopify 标头自身启用了粘性模式时，锚点导航才临时隐藏标头。
     * sticky = none 时标头属于正常文档流，不能延迟移出或恢复，否则快速
     * 返回页面顶部时会在标头原位留下空白。
     */
    function canAnchorHideHeader() {
      var header = document.querySelector('.section-header header[data-sticky]');
      return Boolean(header && header.getAttribute('data-sticky') !== 'none');
    }

    function setAnchorHeaderHidden(hidden) {
      document.body.classList.toggle(
        'ap-header-hidden',
        Boolean(hidden && canAnchorHideHeader())
      );
    }

    /** 测量 Shopify header 当前显示高度并写入全局变量 --header-h：
     *  - header 隐藏（.shopify-section-header-hidden）时置 0，tabs 贴顶
     *  - header 显示时直接实测 .section-header 的可视底边距视口顶的距离，
     *    避免按子组件相加（#header-sticky / announcement / top-bar）出现重复或漏算 */
    function syncHeaderOffset() {
      // anchor-point 吸顶显示时强制隐藏了 header，此时 header 不占视觉高度，tabs 贴顶
      if (document.body.classList.contains('ap-header-hidden')) {
        document.documentElement.style.setProperty('--header-h', '0px');
        return;
      }
      var headerEl = document.querySelector('.section-header');
      if (!headerEl) {
        document.documentElement.style.setProperty('--header-h', '0px');
        return;
      }
      var hidden = headerEl.classList.contains('shopify-section-header-hidden');
      var h = 0;
      if (!hidden) {
        // 实测 header section 当前的可视底部（相对视口），clip 到 >= 0
        var rect = headerEl.getBoundingClientRect();
        h = Math.max(0, rect.bottom);
      }
      document.documentElement.style.setProperty('--header-h', h + 'px');
    }

    /** 平滑滚动到目标，并扣除吸顶 tabs 高度 */
    function scrollToTarget(target) {
      if (!target) return;
      var top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    /**
     * 使用真实目标元素的固定 id 更新 URL。Tab 标题可以翻译，但 URL fragment
     * 永远来自目标 id，不会从可见文字推导，也不会保留 Transcy 产生的 #-5。
     */
    function syncLocationHash(target, replace) {
      var canonicalId = getElementId(target);
      if (!canonicalId) return;
      var canonicalHash = '#' + encodeURIComponent(canonicalId);
      var currentId = normalizeAnchorId(window.location.hash);
      if (currentId === canonicalId) return;

      try {
        var method = replace ? 'replaceState' : 'pushState';
        window.history[method](
          window.history.state,
          '',
          window.location.pathname + window.location.search + canonicalHash
        );
      } catch (e) {
        // 极旧浏览器不支持 History API 时仍保留已完成的页面滚动，不中断导航。
      }
    }

    function updateDotScale() {
      var width = Math.max(1, tabsWrap.offsetWidth);
      var height = Math.max(1, tabsWrap.offsetHeight);
      var dotScale = Math.max(0.035, Math.min(0.35, height / width));
      tabsWrap.style.setProperty('--ap-dot-scale', dotScale.toFixed(4));
    }

    function finishEntering() {
      enterTimer = null;
      if (!isSticky) return;
      tabsWrap.classList.remove('is-entering');
      section.classList.remove('ap-is-entering');
      updateOverflowBtn();
    }

    function enterStickyNavigation() {
      if (enterTimer) clearTimeout(enterTimer);
      if (leaveTimer) clearTimeout(leaveTimer);
      leaveTimer = null;

      tabsWrap.classList.remove('is-leaving');
      section.classList.remove('ap-is-leaving');
      tabsWrap.classList.add('is-sticky');
      updateDotScale();
      /*
       * has-featured：未吸顶时 tabs 本就不占文档流，吸顶再插 spacer
       * 会凭空增高；向上滚消失时撤掉 spacer 就会整页上跳。此场景不加占位。
       * 无 featured：tabs 从文档流抽成 fixed，仍需 spacer 防塌陷。
       */
      if (!section.classList.contains('has-featured')) {
        spacer.style.height = tabsWrap.offsetHeight + 'px';
        spacer.classList.add('is-active');
      }
      setAnchorHeaderHidden(true);
      syncHeaderOffset();

      tabsWrap.classList.add('is-entering');
      section.classList.add('ap-is-entering');
      if (reducedMotionQuery.matches) {
        finishEntering();
      } else {
        enterTimer = setTimeout(finishEntering, enterTotalDuration);
      }
      updateOverflowBtn();
    }

    function finishLeaving() {
      leaveTimer = null;
      if (isSticky) return;
      tabsWrap.classList.remove('is-leaving', 'is-entering', 'is-sticky');
      section.classList.remove('ap-is-leaving', 'ap-is-entering');
      spacer.classList.remove('is-active');
      spacer.style.height = '';
      setAnchorHeaderHidden(false);
      syncHeaderOffset();
      updateOverflowBtn();
    }

    function leaveStickyNavigation() {
      if (enterTimer) clearTimeout(enterTimer);
      if (leaveTimer) clearTimeout(leaveTimer);
      enterTimer = null;

      updateDotScale();
      tabsWrap.classList.remove('is-entering');
      section.classList.remove('ap-is-entering');
      /* 退出过程中保留 is-sticky，避免中途摘掉 fixed 导致顶部露一条再二次隐藏 */
      tabsWrap.classList.add('is-leaving');
      section.classList.add('ap-is-leaving');
      updateOverflowBtn();

      if (reducedMotionQuery.matches) {
        finishLeaving();
      } else {
        leaveTimer = setTimeout(finishLeaving, exitTotalDuration);
      }
    }

    /** 根据滚动位置切换吸顶：当 .sec__featured-product 模块完全滚出视口顶部后才显示 tabs */
    function updateSticky() {
      var shouldStick = window.pageYOffset >= stickTriggerTop;
      if (shouldStick === isSticky) return;

      isSticky = shouldStick;
      if (isSticky) {
        enterStickyNavigation();
      } else {
        leaveStickyNavigation();
      }
    }

    // ========== PC / 移动端左右溢出提示 ==========
    function createOverflowButton(direction) {
      var button = document.createElement('button');
      var isPrevious = direction === 'left';
      button.type = 'button';
      button.className = 'ap-tabs-overflow-btn ap-tabs-overflow-btn--' + direction;
      button.setAttribute('aria-label', isPrevious ? '显示前面的 Tab' : '显示后面的 Tab');
      button.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="' + (isPrevious ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>';
      section.appendChild(button);
      return button;
    }

    var overflowPrevBtn = createOverflowButton('left');
    var overflowNextBtn = createOverflowButton('right');

    function syncOverflowButtonPosition(button, left, tabsRect) {
      var isFixed = isSticky || tabsWrap.classList.contains('is-leaving');
      button.classList.toggle('is-fixed', isFixed);
      if (isFixed) {
        button.style.left = Math.round(left) + 'px';
        button.style.top = Math.round(tabsRect.top) + 'px';
        button.style.height = Math.round(tabsRect.height) + 'px';
      } else {
        button.style.removeProperty('left');
        button.style.removeProperty('top');
        button.style.removeProperty('height');
      }
    }

    /** 检测两侧剩余滚动距离，并同步渐隐箭头和吸顶位置。 */
    function updateOverflowBtn() {
      updateTabsOverflowState(tabsWrap);
      var maxScrollLeft = getMaxScrollLeft(tabsWrap);
      var hasOverflow = maxScrollLeft > 2;
      var atStart = tabsWrap.scrollLeft <= 2;
      var atEnd = tabsWrap.scrollLeft >= maxScrollLeft - 2;
      var isFixed = isSticky || tabsWrap.classList.contains('is-leaving');
      overflowPrevBtn.classList.toggle('is-visible', hasOverflow && !atStart);
      overflowNextBtn.classList.toggle('is-visible', hasOverflow && !atEnd);
      overflowPrevBtn.classList.toggle('is-fixed', isFixed);
      overflowNextBtn.classList.toggle('is-fixed', isFixed);

      var tabsRect = tabsWrap.getBoundingClientRect();
      syncOverflowButtonPosition(overflowPrevBtn, tabsRect.left, tabsRect);
      syncOverflowButtonPosition(overflowNextBtn, tabsRect.right - overflowNextBtn.offsetWidth, tabsRect);
    }

    /** 点击左右箭头：按导航可视宽度的 60% 平滑移动。 */
    overflowPrevBtn.addEventListener('click', function () {
      var step = Math.max(60, tabsWrap.clientWidth * 0.6);
      tabsWrap.scrollBy({ left: -step, behavior: 'smooth' });
    });

    overflowNextBtn.addEventListener('click', function () {
      var step = Math.max(60, tabsWrap.clientWidth * 0.6);
      tabsWrap.scrollBy({ left: step, behavior: 'smooth' });
    });

    // 用户滑动 tabs 容器时，实时刷新箭头可见性（已到末尾时自动隐藏）
    var tabsScrollRaf = null;
    tabsWrap.addEventListener('scroll', function () {
      if (tabsScrollRaf) return;
      tabsScrollRaf = window.requestAnimationFrame(function () {
        tabsScrollRaf = null;
        updateOverflowBtn();
      });
    }, { passive: true });

    /* 吸顶进入动画完成后再同步一次，确保两侧按钮与最终位置完全重合。 */
    tabsWrap.addEventListener('animationend', function (event) {
      if (event.target === tabsWrap) updateOverflowBtn();
    });

    // 点击滚动期间跳过 scroll spy，避免状态抖动
    var isClickScrolling = false;
    var clickTimer = null;

    /** 切换激活 tab */
    function setActive(tab, forcePosition) {
      var changed = !tab.classList.contains('is-active');
      tabs.forEach(function (item) {
        var isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        if (isActive) item.setAttribute('aria-current', 'location');
        else item.removeAttribute('aria-current');
      });
      if (changed || forcePosition) scrollTabIntoView(tabsWrap, tab, 'smooth');
    }

    /** 根据页面滚动位置高亮对应 tab */
    function activateByScroll() {
      if (isClickScrolling) return;

      var offset = getScrollOffset() + 16;
      var current = null;
      var minDistance = Infinity;

      tabs.forEach(function (tab) {
        var target = resolveTabTarget(tab);
        if (!target) return;
        var top = target.getBoundingClientRect().top - offset;
        var distance = Math.abs(top);
        // 优先选已滚过视口顶部、且距离最近的锚点
        if (top <= 0 && distance < minDistance) {
          minDistance = distance;
          current = tab;
        }
      });

      // 若尚未滚到任何锚点，选第一个仍在视口下方的
      if (!current) {
        for (var i = 0; i < tabs.length; i++) {
          var t = resolveTabTarget(tabs[i]);
          if (t && t.getBoundingClientRect().top - offset > 0) {
            current = tabs[i];
            break;
          }
        }
      }

      if (current) setActive(current);
    }

    // 点击 tab → 平滑滚动到锚点
    section.addEventListener('click', function (event) {
      var tab = event.target.closest('.ap-tab');
      if (!tab || !section.contains(tab)) return;

      var target = resolveTabTarget(tab);
      // 找不到目标时保留浏览器原生 href 行为；找到后才接管平滑滚动及吸顶偏移。
      if (!target) return;

      event.preventDefault();
      setActive(tab, true);
      syncLocationHash(target, false);

      isClickScrolling = true;
      scrollToTarget(target);

      if (clickTimer) clearTimeout(clickTimer);
      clickTimer = setTimeout(function () {
        isClickScrolling = false;
      }, 800);
    });

    // 键盘操作：方向键逐项选择，Home/End 直接选择首末项。
    tabsWrap.addEventListener('keydown', function (event) {
      var currentTab = event.target.closest('.ap-tab');
      if (!currentTab || !tabsWrap.contains(currentTab)) return;
      var currentIndex = tabs.indexOf(currentTab);
      var nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = Math.min(tabs.length - 1, currentIndex + 1);
      else if (event.key === 'ArrowLeft') nextIndex = Math.max(0, currentIndex - 1);
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = tabs.length - 1;
      else return;

      event.preventDefault();
      var nextTab = tabs[nextIndex];
      nextTab.focus({ preventScroll: true });
      if (nextTab !== currentTab) nextTab.click();
      else scrollTabIntoView(tabsWrap, nextTab, 'smooth');
    });

    // 滚动监听（rAF 节流）→ 吸顶 + 自动高亮当前 tab
    var scrollRaf = null;
    window.addEventListener(
      'scroll',
      function () {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = null;
          syncHeaderOffset();
          updateSticky();
          activateByScroll();
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      syncHeaderOffset();
      measureOrigin();
      updateSticky();
      updateOverflowBtn();
      scrollTabIntoView(tabsWrap, section.querySelector('.ap-tab.is-active') || tabs[0], 'auto');
    });

    window.addEventListener('load', function () {
      syncHeaderOffset();
      updateOverflowBtn();
      scrollTabIntoView(tabsWrap, section.querySelector('.ap-tab.is-active') || tabs[0], 'auto');
    });

    syncHeaderOffset();
    measureOrigin();
    updateSticky();
    updateOverflowBtn();
    activateByScroll();
    scrollTabIntoView(tabsWrap, section.querySelector('.ap-tab.is-active') || tabs[0], 'auto');

    /*
     * 兼容直接访问 Transcy 历史链接（例如 /ja-jp/products/magic#-5）。
     * 只在该目标确实属于本导航时修正为 #magic-5，其他页面 hash 不受影响。
     */
    if (window.location.hash) {
      var initialHashId = normalizeAnchorId(window.location.hash);
      var initialTarget = resolveTarget(initialHashId) || recoverTranslatedTarget(initialHashId);
      var initialTab = null;

      if (initialTarget) {
        for (var initialIndex = 0; initialIndex < tabs.length; initialIndex++) {
          if (resolveTabTarget(tabs[initialIndex]) === initialTarget) {
            initialTab = tabs[initialIndex];
            break;
          }
        }
      }

      if (initialTab && initialTarget) {
        repairTabAnchor(initialTab, initialTarget);
        syncLocationHash(initialTarget, true);
        setActive(initialTab, true);
        isClickScrolling = true;
        window.requestAnimationFrame(function () {
          scrollToTarget(initialTarget);
          if (clickTimer) clearTimeout(clickTimer);
          clickTimer = window.setTimeout(function () {
            isClickScrolling = false;
          }, 800);
        });
      }
    }
    // 初始布局、吸顶状态和圆点比例都确定后再允许绘制。
    // 这样慢网速下不会先闪现完整空白胶囊，吸顶场景会直接从圆点关键帧开始。
    window.clearTimeout(revealFallbackTimer);
    section.classList.remove('ap-is-pending');
    section.removeAttribute('aria-busy');
  }

  /** 初始化 root 内所有锚点模块（支持同页多实例） */
  function initAll(root) {
    if (root.matches && root.matches('[data-anchor-point]')) initSection(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[data-anchor-point]').forEach(initSection);
    }
  }

  window.BoyaAnchorPoint = { initAll: initAll };
  initAll(document);

  // 主题编辑器内 section 重载后重新初始化
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
